var StudentAvatar = require("components/avatars/StudentAvatar");
var AdminAvatar = require("components/avatars/AdminAvatar");
var SponsorAvatar = require("components/avatars/SponsorAvatar");

class UserAvatar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		if (this.props.user.is_student || (this.props.user.is_admin && this.props.user.avatar)) {
			return <StudentAvatar student={ this.props.user } maxWidth={ this.props.maxWidth } maxHeight={ this.props.maxHeight } />

		} else if (this.props.user.is_admin) {
			return <AdminAvatar admin={ this.props.user } maxWidth={ this.props.maxWidth } maxHeight={ this.props.maxHeight } />

		} else if (this.props.user.is_sponsor) {
			return <SponsorAvatar sponsor={ this.props.user } maxWidth={ this.props.maxWidth } maxHeight={ this.props.maxHeight } />

		} else if (this.props.user.is_wizard) {
			return <StudentAvatar student={ this.props.user } maxWidth={ this.props.maxWidth } maxHeight={ this.props.maxHeight } />
		}
	}
};

UserAvatar.propTypes = StrictPropTypes({
	user: PropTypes.object.isRequired,

	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number
});

module.exports = UserAvatar;


// WEBPACK FOOTER //
// ./modules/components/avatars/UserAvatar.js